/* Leads */
export const ADD_CONTACT = "ADD_CONTACT"
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS"
export const ADD_CONTACT_ERROR = "ADD_CONTACT_ERROR"

export const GET_CONTACT_DETAIL = "GET_CONTACT_DETAIL"
export const GET_CONTACT_DETAIL_SUCCESS = "GET_CONTACT_DETAIL_SUCCESS"
export const GET_CONTACT_DETAIL_FAIL = "GET_CONTACT_DETAIL_FAIL"


export const GET_BUYER_QUES_DETAIL = "GET_BUYER_QUES_DETAIL"
export const GET_BUYER_QUES_DETAIL_SUCCESS = "GET_BUYER_QUES_DETAIL_SUCCESS"
export const GET_BUYER_QUES_DETAIL_FAIL = "GET_BUYER_QUES_DETAIL_FAIL"


export const ADD_BUYER_QUES = "ADD_BUYER_QUES"
export const ADD_BUYER_QUES_SUCCESS = "ADD_BUYER_QUES_SUCCESS"
export const ADD_BUYER_QUES_FAIL = "ADD_BUYER_QUES_FAIL"




export const ADD_TAB_NOTE = "ADD_TAB_NOTE"
export const ADD_TAB_NOTE_SUCCESS = "ADD_TAB_NOTE_SUCCESS"
export const ADD_TAB_NOTE_FAIL = "ADD_TAB_NOTE_SUCCESS"



export const ADD_TAB_EMAIL = "ADD_TAB_EMAIL"
export const ADD_TAB_EMAIL_SUCCESS = "ADD_TAB_EMAIL_SUCCESS"
export const ADD_TAB_EMAIL_FAIL = "ADD_TAB_EMAIL_FAIL"



export const ADD_TAB_CALL = "ADD_TAB_CALL"
export const ADD_TAB_CALL_SUCCESS = "ADD_TAB_CALL_SUCCESS"
export const ADD_TAB_CALL_FAIL = "ADD_TAB_CALL_FAIL"


export const GET_TAB_CALL = "GET_TAB_CALL"
export const GET_TAB_CALL_SUCCESS = "GET_TAB_CALL_SUCCESS"
export const GET_TAB_CALL_FAIL = "GET_TAB_CALL_FAIL"


export const GET_TAB_EMAIL = "GET_TAB_EMAIL"
export const GET_TAB_EMAIL_SUCCESS = "GET_TAB_EMAIL_SUCCESS"
export const GET_TAB_EMAIL_FAIL = "GET_TAB_EMAIL_FAIL"


export const GET_TAB_NOTE = "GET_TAB_NOTE"
export const GET_TAB_NOTE_SUCCESS = "GET_TAB_NOTE_SUCCESS"
export const GET_TAB_NOTE_FAIL = "GET_TAB_NOTE_FAIL"


export const ADD_CONTACT_APP = "ADD_CONTACT_APP"
export const ADD_CONTACT_APP_SUCCESS = "ADD_CONTACT_APP_SUCCESS"
export const ADD_CONTACT_APP_FAIL = "ADD_CONTACT_APP_FAIL"


export const GET_CONTACT_APP = "GET_CONTACT_APP"
export const GET_CONTACT_APP_SUCCESS = "GET_CONTACT_APP_SUCCESS"
export const GET_CONTACT_APP_FAIL = "GET_CONTACT_APP_FAIL"

export const GET_CONTACT_APP_DETAIL = "GET_CONTACT_APP_DETAIL"
export const GET_CONTACT_APP_DETAIL_SUCCESS = "GET_CONTACT_APP_DETAIL_SUCCESS"
export const GET_CONTACT_APP_DETAIL_FAIL = "GET_CONTACT_APP_DETAIL_FAIL"

export const GET_ALL_CONTACT_ACTIVITY = "GET_ALL_CONTACT_ACTIVITY"
export const GET_ALL_CONTACT_ACTI_SUCCESS = "GET_ALL_CONTACT_ACTI_SUCCESS"
export const GET_ALL_CONTACT_ACTIVITY_FAIL = "GET_ALL_CONTACT_ACTIVITY_FAIL"


